import { useAuth } from '@/contexts/AuthContext';
import { useSettingsQuery } from '@/hooks/queries/useSettingsQuery';
import { useTechniciansQuery } from '@/features/technicians/hooks/useTechniciansQuery';
import { useOrdersInfiniteQuery, useArchivedOrdersInfiniteQuery } from '@/features/orders/hooks/useOrdersQuery';
import { useOrderMutations } from '@/features/orders/hooks/useOrderMutations';

export function useOrdersDomain() {
    const { isAuthenticated, isLoading: authLoading, user } = useAuth();
    const enabled = isAuthenticated && !authLoading;

    const settingsQuery = useSettingsQuery(enabled);
    const techniciansQuery = useTechniciansQuery(enabled);
    const ordersQuery = useOrdersInfiniteQuery(enabled);
    const archivedOrdersQuery = useArchivedOrdersInfiniteQuery(undefined, undefined, undefined, enabled);

    const authCompanyId = user?.app_metadata?.company_id as string | undefined;
    const computedCompanyId = settingsQuery.data?.id || authCompanyId || '';

    const technicians = techniciansQuery.data ?? [];
    
    // Extract arrays directly
    const orders = ordersQuery.orders;
    const activeOrders = ordersQuery.activeOrders;
    const archivedOrders = archivedOrdersQuery.archivedOrders;

    const orderMutations = useOrderMutations(computedCompanyId, orders, technicians);

    return {
        // Data
        orders,
        activeOrders,
        archivedOrders,
        
        // Load More Actions
        loadMoreActiveOrders: ordersQuery.loadMoreActiveOrders,
        loadMoreArchivedOrders: archivedOrdersQuery.loadMoreArchivedOrders,
        
        // Loading States
        isLoading: ordersQuery.isLoading,
        isFetchingOrders: ordersQuery.isFetching,
        isArchivedLoading: archivedOrdersQuery.isLoading,
        isArchivedFetching: archivedOrdersQuery.isFetching,

        // Error States
        error: ordersQuery.error || archivedOrdersQuery.error,

        // Mutations
        ...orderMutations
    };
}
